import { render, staticRenderFns } from "./ColumnsFilter.vue?vue&type=template&id=4b4ce418&scoped=true&"
import script from "./ColumnsFilter.vue?vue&type=script&lang=js&"
export * from "./ColumnsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsFilter.vue?vue&type=style&index=0&id=4b4ce418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ce418",
  null
  
)

export default component.exports